import { useSelector } from 'react-redux';
import isSubscribedTo from '@/utils/subscriptionsHelper';
import { datasetSubscriptions } from '@/notifications/subscribers/constants';
import { states } from '@/constants/lifecycle';
import { datasetSettingsFields } from '@/datasets/settings/state/state';
import { resolveRequestWorkflow } from '../../state/state';

const useDatasetSubscribeMessageContainer = ({ category, code }) => useSelector(({
  requests: { requests },
  workflows: { workflows },
}) => {
  const { request } = resolveRequestWorkflow(requests, workflows, { category, code });
  const { steps } = request;
  const readStatus = steps.subscriptionsReadStatus;
  const source = steps.results[0] || {
    settings: datasetSettingsFields(),
    subscriptions: [],
    catalogue: { title: null },
  };
  const ready = [states.ERROR, states.SUCCESS].includes(readStatus);

  return {
    canSubscribe: source.settings.allow_dataset_update_subscriptions && ready,
    errors: steps.subscriptionsErrors.concat(steps.subscriptionsReadErrors),
    name: source.catalogue.title,
    readStatus,
    saveStatus: steps.subscriptionsStatus,
    subscribed: ready && isSubscribedTo(source, datasetSubscriptions.DATASET_UPDATE),
  };
});

export default {
  useDatasetSubscribeMessageContainer,
};
